import { render, staticRenderFns } from "./payment-red-add-or-update.vue?vue&type=template&id=20d510a0&scoped=true"
import script from "./payment-red-add-or-update.vue?vue&type=script&lang=js"
export * from "./payment-red-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./payment-red-add-or-update.vue?vue&type=style&index=0&id=20d510a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d510a0",
  null
  
)

export default component.exports